'use client';
/*
 * @providesModule ConfettiView
 *
 */
import React from 'react';
import {View, StyleProp, ViewStyle, ViewProps} from 'react-native';
import Confetti from 'react-confetti';

interface ConfettiViewProps {
  shouldPlay?: boolean;
  // Mirror the native ConfettiView, which renders `<View style={this.props.style}>`.
  // Dropping `style` silently un-lays-out every DialogV3/HeaderModal/*SuccessModal on web.
  style?: StyleProp<ViewStyle>;
  children?: ViewProps['children'];
}

export default function ConfettiView({shouldPlay, style, children}: ConfettiViewProps) {
  return (
    <View style={style}>
      {shouldPlay && <Confetti />}
      {children}
    </View>
  );
}
